var getPlaceInfoByID = function getPlaceInfoByID(id, placeInfoRef, requestFields, callback) {
  if (id) {
    var service = new google.maps.places.PlacesService(placeInfoRef);
    service.getDetails({
      placeId: id,
      fields: requestFields
    }, function (place, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        callback(place);
      }
    });
  }
};
export var getPlaceInfoByIDPromise = function getPlaceInfoByIDPromise(id, placeInfoRef) {
  return id ? new Promise(function (resolve, reject) {
    var service = new google.maps.places.PlacesService(placeInfoRef);
    service.getDetails({
      placeId: id
    }, function (place, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        resolve(place);
      } else {
        reject(place);
      }
    });
  }) : Promise.resolve();
};
export default getPlaceInfoByID;
export var getPlaceInfoByIDWithoutMap = function getPlaceInfoByIDWithoutMap(id, requestFields, callback) {
  if (id) {
    var map = new google.maps.Map(document.createElement('div'));
    var service = new google.maps.places.PlacesService(map);
    service.getDetails({
      placeId: id,
      fields: requestFields
    }, function (place, status) {
      if (status === google.maps.places.PlacesServiceStatus.OK) {
        callback(place);
      }
    });
  }
};